import React, {Component} from 'react';
import {BrowserRouter, Route, Switch, Redirect} from 'react-router-dom';
import {getParams} from './utils/functions'

import Journals from './containers/journal/admin/journals';
import Journal from './containers/journal/admin/journal';
import Resources from './containers/resource/admin/resources';
import Resource from './containers/resource/admin/resource';
import Scholars from './containers/scholar/admin/scholars';
import Scholar from './containers/scholar/admin/scholar';
import ImportList from './containers/admin/import/list';
import ImportDetail from './containers/admin/import/detail';
import Export from './containers/admin/export/admin/export';
import Authority from './containers/admin/authority/';
import TypeList from './containers/admin/type/admin/type';
import Adminfooter from './components/admin/etc/adminfooter';
import Analysis from './containers/admin/analysis';

import {BASE_PATH} from "./wpconfig";

class AdminApp extends Component {
	render() {
		const query = getParams();

		return (
			<>
				<BrowserRouter>
					<Switch>
						{
							query.page === 'journal' && query.record_id == null
								?
								<Route path={BASE_PATH + 'wp-admin/admin.php'} component={Journals}/>
								:
								query.page === 'journal' && query.record_id != null
									?
									<Route path={[BASE_PATH + 'wp-admin/admin.php']} render={(props) => (
										<Journal key={props.location.search} {...props}/>
									)}/>
									:
									query.page === 'resource' && query.record_id == null
										?
										<Route path={[BASE_PATH + 'wp-admin/admin.php']} component={Resources}/>
										:
										query.page === 'resource' && query.record_id != null
											?
											<Route path={[BASE_PATH + 'wp-admin/admin.php']} render={(props) => (
												<Resource key={props.location.search} {...props}/>
											)}/>
											:
											query.page === 'scholar' && query.record_id == null
												?
												<Route path={[BASE_PATH + 'wp-admin/admin.php']} component={Scholars}/>
												:
												query.page === 'scholar' && query.record_id != null
													?
													<Route path={[BASE_PATH + 'wp-admin/admin.php']} render={(props) => (
														<Scholar key={props.location.search} {...props}/>
													)}/>
													:
													query.page === 'researchmind-authority'
														?
														<Route path={[BASE_PATH + 'wp-admin/admin.php']} component={Authority}/>
														:
														query.page === 'researchmind-type'
															?
															<Route path={[BASE_PATH + 'wp-admin/admin.php']} component={TypeList}/>
															:
															query.page === 'researchmind-import' && query.record_id == null
																?
																<Route path={[BASE_PATH + 'wp-admin/admin.php']} component={ImportList}/>
																:
																query.page === 'researchmind-import' && query.record_id != null
																	?
																	<Route path={[BASE_PATH + 'wp-admin/admin.php']} render={(props) => (
																		<ImportDetail key={props.location.search} {...props}/>
																	)}/>
																	:
																	query.page === 'researchmind-export'
																		?
																		<Route path={[BASE_PATH + 'wp-admin/admin.php']} component={Export}/>
																		:
																		query.page === 'researchmind-analysis'
																			?
																			<Route path={[BASE_PATH + 'wp-admin/admin.php']} component={Analysis}/>
																				:
																				''
						}
					</Switch>
				</BrowserRouter>
				<Adminfooter/>
			</>
		);
	}
}

export default AdminApp;
